import type { AnalyticsEvent, AnalyticsEventPageProperties, ErrorProperties } from "@octopusdeploy/portal-analytics";
import { getErrorProperties } from "@octopusdeploy/portal-analytics";
import type { PageInstanceSummary } from "@octopusdeploy/portal-routes";

interface SaveLicenseKeyAnalyticsEvent extends AnalyticsEvent<"Save License Key">, AnalyticsEventPageProperties, ErrorProperties {
    "Resource Type": "License";
    "Action Type": "Save";
    Status: "Success" | "Failed";
    ["Duration (ms)"]: number;
}

interface SaveLicenseKeyAnalyticsEventArguments {
    page: PageInstanceSummary;
    durationInMs: number;
    status: "Success" | "Failed";
    error?: Error;
}

export function createSaveLicenseKeyAnalyticsEvent({ page, durationInMs, status, error }: SaveLicenseKeyAnalyticsEventArguments): SaveLicenseKeyAnalyticsEvent {
    const errorProperties = getErrorProperties(error);
    return {
        eventName: "Save License Key",
        "Resource Type": "License",
        "Action Type": "Save",
        Status: status,
        "Duration (ms)": durationInMs,
        "Page Id": page.Id,
        "Page Area": page.Area,
        ...errorProperties,
    };
}
